"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Rx_1 = require("rxjs/Rx");
const uris_1 = require("../globals/uris");
const control_1 = require("../model/control");
/**
 * A wrapper for dymo-core controls to be used as Angular UI controls.
 */
class UIControl extends control_1.Control {
    constructor(uri, name, type, store) {
        super(uri, name, type, store);
        this.inValueStream = new Rx_1.BehaviorSubject(null);
        this.outValueStream = new Rx_1.BehaviorSubject(null);
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            let frequency = yield this.store.findControlParamValue(this.uri, uris_1.AUTO_CONTROL_FREQUENCY);
            frequency = frequency ? frequency : 100;
            this.inValueStream
                .auditTime(frequency)
                .subscribe(v => this.setValue(v));
        });
    }
    setUIValue(newValue) {
        this.uiValue = newValue;
        this.outValueStream.next(newValue);
    }
    getUIValueObserver() {
        return this.outValueStream;
    }
    update() {
        if (this.getType() == uris_1.BUTTON) {
            if (isNaN(this.uiValue)) {
                this.setUIValue(0);
            }
            this.setUIValue(1 - this.uiValue);
        }
        if (this.uiValue == true) {
            this.inValueStream.next(1);
        }
        else if (this.uiValue == false) {
            this.inValueStream.next(0);
        }
        else {
            this.inValueStream.next(this.uiValue);
        }
    }
    //for use outside of ui (simulation and tests)
    updateValue(value) {
        this.uiValue = value;
        this.update();
    }
    //called from above when the Control's value changes
    setValue(newValue) {
        if (super.setValue(newValue)) {
            if (this.getType() == uris_1.TOGGLE) {
                if (newValue == 1) {
                    this.setUIValue(true);
                }
                else {
                    this.setUIValue(false);
                }
            }
            else {
                this.setUIValue(newValue);
            }
            return true;
        }
    }
}
exports.UIControl = UIControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/uicontrol.js
// module id = 411
// module chunks = 3